module.exports = __webpack_public_path__ + "img/facebook.bc7da93f.svg";